// extracted by mini-css-extract-plugin
export default {"container":"SymptomSearch_container__KAprj","searchField":"SymptomSearch_searchField__eI9e1","btn":"SymptomSearch_btn__7Pcjb"};